export default "__VITE_ASSET__CPLy6pXY__"